class WebRtcConfigurator {
    configServerUrl: any

    currentConfig: any

    constructor() {
        this.configServerUrl = window._env_.REACT_APP_WEBRTC_CONFIG_URL
        this.currentConfig = null
    }

    async fetchRemoteConfig() {
        const configRes = await fetch(this.configServerUrl)
            .then((resp) => resp.json())
            .then((data) => data)
            .catch((error) => {
                console.warn(`WebRtcConfigurator fetchRemoteConfig error ${JSON.stringify(error)}`)
                return null
            })

        this.currentConfig = configRes
        return configRes
    }

    getStunServerConfig() {
        if (this.currentConfig.length === 4) {
            return this.currentConfig[0]
        }
        return null
    }

    getTurnSslServerConfig() {
        if (this.currentConfig.length === 4) {
            return this.currentConfig[3]
        }
        return null
    }

    static getStaticGoogleStunConfig() {
        return {
            url: 'stun:stun.1.google.com:19302',
        }
    }
}

export default WebRtcConfigurator
